import StyleBase from '../../../styles/base';

const styles: any = {
  aboutText: {
    color: '#323232',
    fontSize: 14,
    marginTop: 15,
    textAlign: 'left',
  },
  addressStyle: {
    alignSelf: 'flex-start',
    color: '#323232',
    fontSize: 12,
    fontWeight: 'normal',
    textAlign: 'left',
    width: 300,
    [StyleBase.media.desktopXl]: {
      width: 400,
    },
    [StyleBase.media.tablet]: {
      width: 150,
      marginTop: 10,
    },
    [StyleBase.media.mobile]: {
      width: 250,
    },
    [StyleBase.media.desktopMedium]: {
      width: 150,
      marginTop: 10,
    },
  },
  agentDetails: {
    color: '#323232',
    fontSize: 14,
    fontWeight: 400,
    marginTop: 15,
    textAlign: 'left',
    whiteSpace: 'pre-wrap',
  },
  alertContainerBlock: {
    backgroundColor: 'white',
    borderRadius: 24,
    boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 24,
    width: 396,
    [StyleBase.media.desktop]: {
      width: 396,
    },
    [StyleBase.media.tablet]: {
      width: 396,
    },
    [StyleBase.media.mobile]: {
      width: 340,
    },
  },
  alertTitleBlock: {
    fontFamily: '"Sharp Grotesk Semibold", sans-serif',
    fontSize: 18,
    fontWeight: '600',
    margin: '0 0 10px',
    lineHeight: '24px',
  },
  alertSubTextBlock: {
    fontSize: 14,
    lineHeight: '24px',
    margin: '0 0 24px',
  },
  alertButtonsBlock: {
    backgroundColor: 'white',
    borderBottomLeftRadius: 24,
    borderBottomRightRadius: 24,
    //display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginTop: 10,
  },
  alertSubmitButtonBlock: {
    border: '1.6px solid #463264',
    color: 'white',
    backgroundColor: '#463264',
    borderRadius: 24,
    fontSize: 16,
    lineHeight: '24px',
    textTransform: 'inherit',
    minWidth: 79,
    padding: 16,
    '&:hover': {
      color: '#463264',
      backgroundColor: '#E3DEED',
      border: '1.6px solid #E3DEED',
    },
  },
  alertCancelButtonBlock: {
    border: '1.6px solid #463264',
    borderRadius: 24,
    color: '#463264',
    fontSize: 16,
    lineHeight: '24px',
    textTransform: 'inherit',
    minWidth: 178,
    padding: 16,
    '&:hover': {
      color: '#463264',
      backgroundColor: '#E3DEED',
    },
  },
  basicContainer: {
    flex: 1,
    height: 900,
    position: 'relative',
    width: '100%',
  },
  buttonClassName: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    position: 'absolute',
    right: 20,
    top: 20,
    zIndex: 10,
  },
  buttonContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginLeft: 200,
    [StyleBase.media.desktopXl]: {
      paddingLeft: 100,
    },
    [StyleBase.media.desktop]: {
      margin: '10px 0px 10px 200px',
    },
    [StyleBase.media.tablet]: {
      margin: '10px 0px 10px 10px',
    },
    [StyleBase.media.mobile]: {
      marginLeft: 0,
    },
    [StyleBase.media.desktopMedium]: {
      margin: '10px 0px 10px 30px',
    },
  },
  buttonStyle: {
    border: '1px solid #463264',
    height: 40,
    margin: '0 5px',
    minWidth: 110,
    padding: 0,
  },
  disabledButtonStyle: {
    border: '1px solid #C3CAD6',
    backgroundColor: 'rgba(0,0,0,0.1)',
    height: 40,
    margin: '0 5px',
    minWidth: 110,
    padding: 0,
  },
  buttonText: {
    color: '#463264',
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    textTransform: 'none',
  },
  disabledButtonText: {
    color: 'rgb(139, 142, 147)',
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  carouselContentContainer: {
    height: '100%',
    margin: '0 auto',
    overflowY: 'scroll',
    width: '90%',
    [StyleBase.media.desktopXl]: {
      width: 980,
    },
    [StyleBase.media.tablet]: {
      width: '90%',
    },
    [StyleBase.media.mobile]: {
      width: '100%',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  carouselExtraClass: {
    [StyleBase.media.desktopXl]: {
      width: 1100,
    },
  },
  carouselPhoto: {
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    height: '100%',
    objectFit: 'cover',
    zIndex: 2,
  },
  carouselPhotoLoader: {
    left: '40%',
    position: 'absolute',
    top: '40%',
    zIndex: -1,
    [StyleBase.media.mobile]: {
      left: '35%',
      top: '35%',
    },
  },
  column1: {
    marginRight: 'auto',
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: 140,
    paddingLeft: 20,
    [StyleBase.media.tablet]: {
      width: 160,
    },
  },
  column1Inner: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    width: 340,
    [StyleBase.media.tablet]: {
      flexDirection: 'column',
    },
    [StyleBase.media.desktopMedium]: {
      flexDirection: 'column',
    },
  },
  column1InnerTablet: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    width: 340,
  },
  countContainer: {
    alignSelf: 'center',
    display: 'flex',
    position: 'absolute',
    top: 20,
    zIndex: 10,
    [StyleBase.media.tablet]: {
      alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0.75)',
      borderRadius: 5,
      display: 'flex',
      height: 30,
      justifyContent: 'center',
      position: 'absolute',
      top: 20,
      width: 75,
      zIndex: 5,
    },
  },
  countStyle: {
    color: '#323232',
    fontSize: 18,
    [StyleBase.media.tablet]: {
      color: '#323232',
      fontSize: 12,
    },
    [StyleBase.media.mobile]: {
      color: '#FFFFFF',
      fontSize: 14,
    },
  },
  detailsContainer: {
    margin: '0 auto 20px',
    width: 675,
    [StyleBase.media.mobile]: {
      marginBottom: 50,
      width: '100%',
    },
    [StyleBase.media.tablet]: {
      width: 'auto',
    },
  },
  detailsPadder: {
    display: 'flex',
    marginLeft: 25,
    marginTop: 5,
    [StyleBase.media.desktop]: {
      marginLeft: 20,
    },
    [StyleBase.media.tablet]: {
      marginLeft: 0,
    },
    [StyleBase.media.desktopMedium]: {
      marginLeft: 0,
    },
  },
  detailsStyle: {
    alignSelf: 'center',
    color: '#0E1217',
    fontSize: 14,
    [StyleBase.media.tablet]: {
      fontSize: 12,
    },
    [StyleBase.media.mobile]: {
      fontSize: 12,
      marginTop: 5,
    },
  },
  detailsTitle: {
    color: '#0E1217',
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 25,
    textAlign: 'left',
    fontFamily: 'Sharp Grotesk Semibold !important',
  },
  detailsTitleBig: {
    color: '#323232',
    fontSize: 24,
    fontWeight: 700,
    margin: '15px 0 0 0',
    textAlign: 'left',
    fontFamily: 'Sharp Grotesk Semibold !important',
  },
  disclaimer: {
    marginTop: 20,
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
  },
  disclaimerText: {
    color: '#323232',
    fontSize: 10,
    lineHeight: 14,
    marginTop: 10,
    textAlign: 'justify',
    [StyleBase.media.mobile]: {
      marginTop: 15,
    },
  },
  donutLabel: {
    color: '#323232',
    fontSize: 16,
    fontWeight: 400,
    [StyleBase.media.mobile]: {
      fontSize: 12,
    },
  },
  dummyContainer: {
    height: 5,
  },
  estimateContainer: {
    margin: '0 auto',
    width: 675,
    [StyleBase.media.mobile]: {
      width: '100%',
    },
  },
  expandButton: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginTop: 15,
    minWidth: 15,
    padding: 0,
  },
  expandButtonText: {
    color: '#0E1217',
    fontSize: 12,
    textTransform: 'capitalize',
    fontWeight: 'bold',
  },
  footerText: {
    color: '#323232',
    fontSize: 12,
    fontWeight: 'bold',
    textDecoration: 'none',
  },
  fullScreenIcon: {
    padding: 0,
    position: 'absolute',
    right: 10,
    top: 10,
    zIndex: 5,
  },
  headerContainer: {
    boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    display: 'flex',
    flexDirection: 'row',
    height: 75,
    justifyContent: 'space-between',
    width: '100%',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [StyleBase.media.tablet]: {
      height: 120,
    },
    [StyleBase.media.desktopMedium]: {
      height: 120,
    },
  },
  headerContainerTablet: {
    display: 'flex',
    flexDirection: 'row',
    height: 160,
    justifyContent: 'space-between',
    padding: '0 35px 0 0',
    width: '100%',
  },
  iconButtonsContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: 'auto',
  },
  closeModalButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: 48,
    width: 48,
    [StyleBase.media.tablet]: {
      bottom: '3vh',
      left: '8vw',
    },
  },
  closeModalButtonOuter: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: 55,
    width: 60,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  closeButtonOuter: {
    position: 'relative',
    left: '90%',
    bottom: '4vh',
    background: '#fff',
    borderRadius: '50%',
    padding: 5,
  },
  iconContainer: {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 7,
    [StyleBase.media.mobile]: {
      alignItems: 'flex-start',
      height: 'auto',
      marginTop: 0,
    },
  },
  listItem: {
    alignItems: 'center',
    display: 'flex',
    height: 17,
    justifyContent: 'space-between',
    margin: '15px 0 0',
    width: 305,
    [StyleBase.media.mobile]: {
      margin: '15px auto',
      width: '100%',
    },
  },
  listItemsContainer: {
    padding: 0,
    [StyleBase.media.mobile]: {
      width: '100%',
    },
  },
  listLabel: {
    color: '#323232',
    fontSize: 14,
  },
  listValue: {
    color: '#0E1217',
    fontSize: 14,
    maxWidth: 150,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  loginButtonContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 50,
    marginTop: 40,
  },
  mapButton: {
    '&:hover': {
      backgroundColor: 'white',
    },
    backgroundColor: 'white',
    borderRadius: '50%',
    boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    height: 56,
    margin: '5px 0',
    minWidth: 56,
    zIndex: 1,
  },
  mapButtonLabel: {
    color: '#463264',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 12,
    marginTop: 5,
    textTransform: 'capitalize',
  },
  mapCarouselContainer: {
    height: '100%',
    margin: '0 auto',
    paddingTop: 0,
    width: '100%',
  },
  mapCloseButton: {
    backgroundColor: 'white',
    boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    padding: 0,
    position: 'absolute',
    right: 20,
    zIndex: 50,
  },
  mapContainer: {
    position: 'relative',
    width: '100%',
  },
  marginContainer: {
    margin: '15px 0',
    [StyleBase.media.mobile]: {
      margin: 15,
    },
  },
  matterPortContainer: {
    alignItems: 'center',
    backgroundImage: 'linear-gradient(141deg, #443461 10%, #c8bddb 75%);',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
  miniMapButtonsContainer: {
    bottom: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'absolute',
    right: 5,
    zIndex: 10,
  },
  mlsLogo: {
    height: 35,
    objectFit: 'contain',
  },
  mobileDetailsContainer: {
    background: 'linear-gradient(180deg, transparent 0%, #000 100%)',
    bottom: 0,
    position: 'absolute',
    width: '100%',
    zIndex: 10,
  },
  mobileDetailsContent: {
    display: 'flex',
    flexDirection: 'row',
    height: 50,
    justifyContent: 'space-between',
    padding: '0 10px 10px',
    width: '100%',
    zIndex: 10,
  },
  modalContianer: {
    backgroundColor: 'rgba(0,0,0,0.8)',
    position: 'relative',
    zIndex: '98 !important',
  },
  nearbyButton: {
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.75)',
    },
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.75)',
    borderRadius: 5,
    display: 'flex',
    height: 30,
    justifyContent: 'center',
    textTransform: 'capitalize',
    zIndex: 5,
  },
  nearbyButtonContainer: {
    display: 'flex',
    height: 30,
    justifyContent: 'center',
    position: 'absolute',
    top: 15,
    width: '100%',
    zIndex: 5,
  },
  nearbyText: {
    color: '#FFFFFF',
    fontSize: 12,
    textAlign: 'center',
  },
  neighborhoodContainer: {
    margin: '0 auto 20px',
    [StyleBase.media.mobile]: {
      marginBottom: 50,
      width: '100%',
    },
  },
  nullSchoolRatingText: {
    color: '#323232',
    fontSize: 16,
    fontWeight: 'bold',
  },
  pattern: {
    background: 'white',
    height: '100%',
    position: 'absolute',
    width: '100%',
  },
  photoBox: {
    height: 540,
    position: 'relative',
    width: 735,
    [StyleBase.media.tablet]: {
      height: 490,
      width: 650,
    },
  },
  photoCounterContainer: {
    alignItems: 'center',
    bottom: 10,
    display: 'flex',
    flexDirection: 'row',
    height: 25,
    justifyContent: 'space-between',
    position: 'absolute',
    width: 135,
    zIndex: 5,
  },
  photoNavButtons: {
    borderRadius: '50%',
    height: 25,
    minWidth: 25,
    padding: 0,
    [StyleBase.media.tablet]: {
      borderRadius: '50%',
      boxShadow:
        '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
      height: 65,
      minWidth: 65,
      padding: 0,
    },
  },
  photoNavButtonsContainer: {
    [StyleBase.media.tablet]: {
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      position: 'absolute',
    },
  },
  photoStyle: {
    height: '100%',
    objectFit: 'cover',
    width: '100%',
  },
  photoToggleButton: {
    height: 30,
    minWidth: 15,
    padding: 0,
  },
  photoViewerContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
    [StyleBase.media.tablet]: {
      padding: 0,
    },
  },
  photoViewerContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: 540,
    justifyContent: 'space-evenly',
    width: '100%',
  },
  photosActionIcons: {
    bottom: 10,
    display: 'flex',
    height: 50,
    justifyContent: 'center',
    position: 'absolute',
    right: 20,
    zIndex: 12,
    [StyleBase.media.mobile]: {
      bottom: 50,
      right: 10,
    },
  },
  photosCarouselContentContainer: {
    height: '100%',
    margin: '0 auto',
    overflowY: 'scroll',
    paddingTop: 30,
    width: 890,
    [StyleBase.media.desktopXl]: {
      width: 980,
    },
    [StyleBase.media.tablet]: {
      width: 690,
    },
    [StyleBase.media.mobile]: {
      paddingTop: 0,
      width: '100%',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  photosCloseButton: {
    borderRadius: '50%',
    height: 25,
    minWidth: 25,
    padding: 0,
    position: 'absolute',
    right: 15,
    top: 20,
    zIndex: 10,
    [StyleBase.media.tablet]: {
      height: 30,
      minWidth: 30,
      right: 25,
    },
  },
  photosContainer: {
    height: 400,
    margin: '0 auto',
    width: '100%',
    [StyleBase.media.mobile]: {
      width: '100%',
    },
  },
  photosContainerStyle: {
    '&:hover': {
      cursor: 'pointer',
    },
    backgroundImage: 'linear-gradient(141deg, #443461 10%, #c8bddb 75%)',
    position: 'relative',
    width: '100%',
    [StyleBase.media.mobile]: {
      left: '0px !important',
      width: '100% !important',
    },
  },
  photosPriceInfo: {
    bottom: 10,
    display: 'flex',
    height: 50,
    justifyContent: 'flex-start',
    position: 'absolute',
    width: '100%',
    zIndex: 10,
    [StyleBase.media.mobile]: {
      bottom: 50,
      justifyContent: 'flex-start',
      marginLeft: 10,
    },
  },
  policyContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    marginTop: 13,
  },
  priceStyle: {
    alignSelf: 'center',
    color: '#0E1217',
    fontSize: 24,
    fontWeight: 'bold',
    fontFamily: 'Sharp Grotesk Semibold',
    [StyleBase.media.desktop]: {
      alignSelf: 'flex-start',
    },
    [StyleBase.media.tablet]: {
      fontSize: 24,
      alignSelf: 'flex-start',
    },
    [StyleBase.media.mobile]: {
      fontSize: 18,
    },
  },
  savingsContainer: {
    display: 'flex',
    flexDirection: 'column',
    left: 7,
    position: 'absolute',
    top: 5,
    zIndex: 1,
  },
  savingsInfoBox: {
    alignItems: 'center',
    backgroundColor: '#195A50',
    borderRadius: 3,
    display: 'flex',
    justifyContent: 'center',
    width: 175,
    zIndex: 1,
  },
  savingsText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: 'bold',
    whiteSpace: 'pre-wrap',
  },
  scheduledShowingDate: {
    fontSize: 24,
    fontWeight: 'bold',
    marginTop: 20,
  },
  scheduledShowingText: {
    color: '#0E1217',
    fontSize: 14,
    marginTop: 30,
  },
  schoolFilterContainer: {
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    border: '1px solid #C3CAD6',
    borderRadius: '5px 5px 0 0',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 35,
    marginTop: 20,
    width: 386,
    [StyleBase.media.mobile]: {
      width: '100%',
    },
  },
  schoolDetailContainer: {
    backgroundColor: '#FFFFFF',
    border: '0.5px solid #C3CAD6',
    display: 'flex',
    flex: 1,
    height: 147,
    justifyContent: 'space-between',
    width: '100%',
    [StyleBase.media.mobile]: {
      height: 120,
    },
  },
  schoolContent: {
    alignItems: 'left',
    display: 'flex',
    flex: 0.9,
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 15,
  },
  schoolContentInner: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    padding: '2px 0',
    textAlign: 'left',
  },
  schoolContentText: {
    color: '#323232',
    fontSize: 16,
    [StyleBase.media.mobile]: {
      fontSize: 14,
    },
  },
  schoolName: {
    fontSize: 14,
    fontWeight: 700,
    textDecoration: 'none',
  },
  schoolRating: {
    alignItems: 'center',
    borderRadius: 50,
    display: 'flex',
    justifyContent: 'center',
    height: 30,
    width: 30,
  },
  schoolRatingText: {
    color: '#FFFFFF',
    fontSize: 16,
    fontWeight: 'bold',
  },
  schoolRatingContainer: {
    alignItems: 'center',
    display: 'flex',
    flex: 0.1,
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: 10,
    padding: '0 25px',
  },
  schoolTab: {
    '&:hover': {
      backgroundColor: 'rbga(0,0,0,0.3)',
    },
    alignItems: 'center',
    backgroundColor: 'white',
    border: '1px solid #C3CAD6',
    borderLeft: 'none',
    borderRight: 'none',
    borderRadius: 0,
    display: 'flex',
    height: 35,
    justifyContent: 'center',
    minWidth: 95,
    marginLeft: 1,
    [StyleBase.media.mobile]: {
      minWidth: 93,
      marginLeft: 0,
    },
  },
  schoolTabSelected: {
    '&:hover': {
      backgroundColor: '#463264',
    },
    alignItems: 'center',
    backgroundColor: '#463264',
    // border: '1px solid #C3CAD6',
    // borderRadius: 0,
    borderRadius: '5px 5px 0 0',
    display: 'flex',
    height: 35,
    justifyContent: 'center',
    minWidth: 95,
    [StyleBase.media.mobile]: {
      minWidth: 93,
    },
  },
  schoolToggleButtonBox: {
    alignItems: 'center',
    display: 'flex',
    padding: 25,
  },
  schoolToggleText: {
    fontSize: 14,
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  schoolToggleTextBox: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'left',
    padding: 15,
  },
  separator: {
    backgroundColor: '#D8D8D8',
    height: 1,
    margin: '25px 0',
    width: '100%',
  },
  settingsButtonLabel: {
    color: '#463264',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 12,
    textTransform: 'capitalize',
  },
  showingFormContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 auto',
    width: 310,
  },
  showingPriceAlert: {
    color: '#323232',
    fontSize: 22,
    fontWeight: 900,
    marginTop: 15,
  },
  showingPriceAlertContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  showingPriceAlertSubText: {
    fontSize: 14,
    marginTop: 10,
  },
  sideButtonsContainer: {
    bottom: 65,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'revert',
    position: 'fixed',
    right: 15,
  },
  similarContainer: {
    margin: '15px 20px',
    width: '100%',
    [StyleBase.media.mobile]: {
      margin: '15px auto 50px',
    },
  },
  sliderButton: {
    '&:hover': {
      backgroundColor: '#323232',
    },
    backgroundColor: '#323232',
    borderRadius: 2,
    height: 6,
    margin: '7px auto',
    padding: 0,
    width: 40,
  },
  sliderContainer: {
    backgroundColor: 'white',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    boxShadow:
      '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)',
    position: 'absolute',
    zIndex: 1,
  },
  sliderFirstRow: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 10px',
    width: 'auto',
  },
  sliderInnerContainer: {
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    height: '100%',
    width: '100%',
  },
  sliderSecondRow: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '15px 10px 5px',
  },
  sliderThirdRow: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    margin: 20,
  },
  statusContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    margin: '10px 20px 0 0',
    width: '100%',
    [StyleBase.media.mobile]: {
      margin: '0 10px 0 0',
      width: 50,
    },
  },
  statusIndicator: {
    alignSelf: 'center',
    borderRadius: 3.5,
    height: 7,
    marginRight: 5,
    width: 7,
  },
  statusText: { color: '#323232', fontSize: 12 },
  streetViewContainer: {
    alignItems: 'center',
    backgroundImage: 'linear-gradient(141deg, #443461 10%, #c8bddb 75%)',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
  tabButton: {
    '&:hover': {
      backgroundColor: 'rbga(0,0,0,0.3)',
    },
    alignItems: 'center',
    backgroundColor: 'white',
    border: '1px solid #C3CAD6',
    borderRadius: 15,
    display: 'flex',
    height: 30,
    justifyContent: 'center',
    margin: '0 10px 0 0',
    minWidth: 90,
    [StyleBase.media.tablet]: {
      minWidth: 'auto',
    },
    [StyleBase.media.mobile]: {
      minWidth: 'auto',
    },
  },
  tabButtonDisabled: {
    '&:hover': {
      backgroundColor: '#463264',
    },
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.1)',
    border: '1px solid #C3CAD6',
    borderRadius: 15,
    display: 'flex',
    height: 30,
    justifyContent: 'center',
    margin: '0 10px 0 0',
    minWidth: 90,
    [StyleBase.media.mobile]: {
      minWidth: 'auto',
    },
  },
  tabButtonSelected: {
    '&:hover': {
      backgroundColor: '#463264',
    },
    alignItems: 'center',
    backgroundColor: '#463264',
    border: '1px solid #C3CAD6',
    borderRadius: 15,
    display: 'flex',
    height: 30,
    justifyContent: 'center',
    margin: '0 10px 0 0',
    minWidth: 90,
    [StyleBase.media.mobile]: {
      minWidth: 'auto',
    },
  },
  tabButtonText: {
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: '14px !important',
    textTransform: 'capitalize',
    [StyleBase.media.mobile]: {
      fontWeight: 'normal',
    },
    [StyleBase.media.desktopMedium]: {
      fontSize: 11,
    },
  },
  tabContainer: {
    backgroundColor: 'white',
    border: '1px solid #C3CAD6',
    borderLeftWidth: 0,
    borderRightWidth: 0,
    height: 50,
    width: '100%',
    overflow: 'hidden',
    overflowX: 'scroll',
    [StyleBase.media.mobile]: {
      padding: '0 15px',
    },
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  tabInner: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'flex-start',
    marginLeft: 35,
    width: 'auto',
    [StyleBase.media.tablet]: {
      marginLeft: 10,
    },
    [StyleBase.media.mobile]: {
      marginLeft: 0,
    },
  },
  threeDimensionButton: {
    display: 'flex',
    flexDirection: 'column',
  },
  threeDimensionButtonText: {
    color: '#463264',
    fontSize: 12,
    margin: 0,
    textTransform: 'none',
    '&:hover': {
      color: '#463264',
    },
  },
  threeDimensionIcon: {
    backgroundColor: '#ffffff',
    borderRadius: '50%',
    boxShadow: '0 0 4px 1px rgba(0, 0, 0, 0.25)',
    height: 56,
    margin: '0 5px',
    padding: 0,
    minWidth: 56,
    '&:hover': {
      backgroundColor: '#e5e5e5',
    },
  },
  tourWrapper: {
    display: 'flex',
    [StyleBase.media.mobile]: {
      flexDirection: 'column',
    },
    [StyleBase.media.tablet]: {
      flexDirection: 'column',
    },
  },
  tourContainer: {
    width: '100%',
    margin: '20px 0',
    [StyleBase.media.mobile]: {
      width: '100%',
      alignItems: 'center',
    },
    [StyleBase.media.tablet]: {
      alignItems: 'center',
      margin: 'auto',
    },
  },
  trendsText: {
    color: '#0E1217',
    fontSize: 14,
    marginLeft: 10,
    textAlign: 'left',
  },
  scoreContainer: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'scroll',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    [StyleBase.media.mobile]: {
      margin: '0 15px',
    },
  },
  scoreTitle: {
    color: '#323232',
    fontSize: 24,
    fontWeight: 'bold',
    fontFamily: 'Sharp Grotesk Semibold !important',
  },
  scoreProviderText: {
    color: '#555555',
    fontSize: 18,
  },
  scoreContentContainer: {
    border: '1px solid #979797',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'space-evenly',
    margin: '35px 0',
    padding: '30px 0',
    width: 'auto',
    borderRadius: 32,
    [StyleBase.media.tablet]: {
      flexDirection: 'column',
    },
    [StyleBase.media.mobile]: {
      flexDirection: 'column',
      width: '100%',
    },
  },
  individualScoreContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: 300,
    minWidth: 300,
    padding: '0 10px',
    [StyleBase.media.mobile]: {
      maxWidth: 350,
    },
  },
  extraPadder: {
    [StyleBase.media.tablet]: {
      padding: '0 10px 30px',
    },
    [StyleBase.media.mobile]: {
      padding: '0 10px 30px',
    },
  },
  scoreText: {
    color: '#323232',
    fontSize: 21,
    fontWeight: 700,
    textAlign: 'center',
    fontFamily: 'Sharp Grotesk Semibold !important',
  },
  scoreDescriptionText: {
    color: '#555555',
    fontSize: 16,
    fontWeight: 400,
    textAlign: 'center',
  },
  scoreTrademarkText: {
    color: '#555555',
    fontSize: 12,
    fontWeight: 700,
    textAlign: 'center',
  },
  priceHistoryContainer: {
    margin: '15px 0',
    [StyleBase.media.mobile]: {
      margin: 0,
    },
  },
  priceHistoryTitle: {
    [StyleBase.media.mobile]: {
      padding: '0 0 0 15px',
    },
  },
};

export default styles;
